import { Bar } from "react-chartjs-2";
import { SharedIncentiveComponentProps } from "../containers/IncentiveDashboardContainer";
import { useGetIncentiveLineGraphAsAdminQuery } from "../../../lib/apollo/graphql/generated";

export default function IncentiveBarGraph({
  period,
  filters,
}: SharedIncentiveComponentProps) {
  const { year, month } = period;
  const { userId, searchType } = filters;

  const isCaregiverSearch = searchType === "caregivers";

  const { data } = useGetIncentiveLineGraphAsAdminQuery({
    variables: {
      year,
      month,
      caregiverId: isCaregiverSearch && userId ? userId : null,
      guardianId: !isCaregiverSearch && userId ? userId : null,
    },
  });

  const incentives = data?.getIncentiveLineGraphAsAdmin || [];

  const labels = incentives.map(
    (incentive) => incentive.pointTransactionType.name
  );
  const amounts = incentives.map((incentives) => incentives.amount);
  const datasets = [
    {
      label: "지급 금액",
      data: amounts,
      barThickness: 100,
      backgroundColor: ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A73E8"],
    },
  ];

  return (
    <div className="flex h-[500px] min-h-[500px] flex-col pt-3">
      <p className="text-lg font-bold">
        {year}년 {month}월 {filters.query ? `${filters.query.trim()}님` : ""}{" "}
        보상 추이
      </p>
      <div className="h-full px-3 py-5">
        <Bar
          id="incentive-bar-graph"
          data={{
            labels,
            datasets,
          }}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  color: "#666",
                },
              },
              y: {
                beginAtZero: true,
                ticks: {
                  color: "#666",
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
}
